import { Button, Tooltip } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { useHasScopePermission } from "app/hooks";
import PlusIcon from "assets/icons/plus.svg?react";

export function GroupsActionBar() {
  const navigate = useNavigate();

  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    // Search and the identity-provider filter live in the directory below, so
    // the bar holds just the create action, aligned to the right.
    <div className="mb-6 flex items-center justify-end">
      <Tooltip
        title={
          hasSystemEditPermission
            ? ""
            : "You need system edit permissions to add a group"
        }
        asChild
      >
        <span>
          <Button
            IconLeft={<PlusIcon height={20} width={20} />}
            isDisabled={!hasSystemEditPermission}
            onPress={() => navigate("add")}
            variant="primary"
          >
            Create New Group
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
